import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  DeleteHomeScreenBannerImage,
  DeleteHomeScreenBannerImageVariables
} from './__generated__/DeleteHomeScreenBannerImage'

const MUTATION = gql`
  mutation DeleteHomeScreenBannerImage($id: String!) {
    deleteHomeScreenBannerImage: deleteHomeScreenBannerImageV2(id: $id) {
      ... on HomeScreenBannerV2 {
        id
        title
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteHomeScreenBannerImage = () =>
  useMutation<DeleteHomeScreenBannerImage, DeleteHomeScreenBannerImageVariables>(MUTATION)
